import React from "react";
import "./../../style.scss";
import { withStyles, Table, Paper, TableBody } from "@material-ui/core";
import styles from "./styles";
import { formatAddress } from "../../../../modules/Dispatch/utils/utils";
import Header from "../components/Header";
import Content from "../components/Content";
import Footer from "../components/Footer";
import Contact from "../components/Contact";
import {
  getPickupStopContact,
  getPickupContent,
  getDriverDetails,
} from "../utils";
import UnAssignPickup from "../components/UnAssignPickup";
import { PickupPopupMarker, VirtualStopMarker } from "../../../Markers";

const StopPickupPopupInfo = ({
  classes,
  theme,
  unAssignDriver,
  hideAction,
  pickupNumber,
  isDelayStop,
  specialNeeds,
  stopData,
  routesData,
  terminalOffset,
  openDriverChat,
}) => {
  const address = formatAddress({
    address: stopData?.address,
    address2: stopData?.address2,
    city: stopData?.city,
    state: stopData?.state,
    zip: stopData?.zip,
  });
  return (
    <Paper className={`popupBGColor ${classes.mapPopupContainer}`}>
      <Table className={classes.table} padding="none">
        <Header
          name={stopData.name}
          address={address}
          id={pickupNumber}
          stopSequence={stopData.stopSequence}
          isDelayStop={isDelayStop}
          Marker={
            stopData.isVirtualStop ? VirtualStopMarker : PickupPopupMarker
          }
          markerProps= {{ backgroundColor: stopData.color }}
        />
        <TableBody>
          <Contact {...getPickupStopContact(stopData)} />
          {hideAction ? null : (
            <UnAssignPickup
              unAssignDriver={() =>
                unAssignDriver({
                  driverId: routesData.driverId,
                  pickupId: stopData.pickupId,
                })
              }
            />
          )}
          <Content
            data={getPickupContent(stopData)}
            stopData={stopData}
            specialNeeds={specialNeeds}
          />
        </TableBody>
        <Footer
          stopData={stopData}
          driverDetails={getDriverDetails(routesData, terminalOffset)}
          theme={theme}
          openDriverChat={openDriverChat}
        />
      </Table>
    </Paper>
  );
};

export default withStyles(styles)(StopPickupPopupInfo);
